import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TelegramCallbackPage = () => {
  const navigate = useNavigate();
  const { loginWithTelegram } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const processTelegramAuth = async () => {
      // Extract auth data from URL hash or search params
      const hash = window.location.hash.substring(1);
      const hashParams = new URLSearchParams(hash);
      
      // Try to get data from URL
      const authData = {
        id: parseInt(searchParams.get('id') || hashParams.get('id')),
        first_name: searchParams.get('first_name') || hashParams.get('first_name'),
        last_name: searchParams.get('last_name') || hashParams.get('last_name'),
        username: searchParams.get('username') || hashParams.get('username'),
        photo_url: searchParams.get('photo_url') || hashParams.get('photo_url'),
        auth_date: parseInt(searchParams.get('auth_date') || hashParams.get('auth_date')),
        hash: searchParams.get('hash') || hashParams.get('hash'),
      };

      // Validate we have required fields
      if (authData.id && authData.hash && authData.auth_date) {
        // If opened in popup, send data to parent and close
        if (window.opener) {
          // Store in localStorage for parent to read
          localStorage.setItem('telegram_auth_data', JSON.stringify(authData));
          // Also try postMessage
          try {
            window.opener.postMessage({ event: 'auth_result', result: authData }, window.location.origin);
          } catch (e) {
            console.log('PostMessage failed, using localStorage fallback');
          }
          window.close();
          return;
        }
        
        // If not in popup, process login directly
        try {
          const result = await loginWithTelegram(authData);
          if (result.success) {
            navigate('/');
          } else {
            navigate('/login?error=' + encodeURIComponent(result.error || 'Telegram auth failed'));
          }
        } catch (error) {
          navigate('/login?error=' + encodeURIComponent('Telegram auth failed'));
        }
      } else {
        // No valid auth data, check if we're in a popup
        if (window.opener) {
          window.close();
        } else {
          navigate('/login');
        }
      }
    };

    processTelegramAuth();
  }, [loginWithTelegram, navigate, searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0b0e11',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      color: '#fff',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '3px solid #f0b90b',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      <p style={{ marginTop: '16px', color: '#848e9c' }}>
        Авторизация через Telegram...
      </p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default TelegramCallbackPage;
